function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.002,
    height: 12.002,
    viewBox: "0 0 12.002 12.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Email MLR Status"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "checkmark--filled (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 63",
    d: "M14155 1838a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6zm0-4.059a.53.53 0 1 0 .526.53.529.529 0 0 0-.526-.529zm-.352-4.944v3.885h.7V1829z",
    transform: "translate(-14149.001 -1825.999)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 15.539 9 13.4l.682-.682 1.461 1.461L14.319 11l.684.679z",
    transform: "translate(-6.001 -7.142)",
    style: {
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawn);
export default __webpack_public_path__ + "static/media/withdrawn.d43dd7aae99cb9d1761a3d744b4bba41.svg";
export { ForwardRef as ReactComponent };